const UrlParserService = {
  parse(urlQuery: any) {
    let organizationSubdomain = null;
    const locationParts = window.location.hostname.split('.');

    if (locationParts.length === 3) {
      [organizationSubdomain] = locationParts;
    }

    return {
      organizationSubdomain,
      linkId: urlQuery.linkid,
    };
  },
};

export default UrlParserService;
